import { ROOT_URL_HOST } from '@/shared/constants/contactConstants';
import type { IFaqQuestion } from '@/shared/model/types/faq';

export interface BreadcrumbItem {
  name: string;
  url: string;
}

export interface BreadcrumbListItem {
  '@type': 'ListItem';
  position: number;
  name: string;
  item: string;
}

export interface BreadcrumbSchemaData {
  itemListElement: BreadcrumbListItem[];
}

export interface FaqAnswer {
  '@type': 'Answer';
  text: string;
}

export interface FaqQuestionSchema {
  '@type': 'Question';
  name: string;
  acceptedAnswer: FaqAnswer;
}

export interface FaqSchemaData {
  mainEntity: FaqQuestionSchema[];
}

export const buildBreadcrumbData = (items: BreadcrumbItem[]): BreadcrumbSchemaData => ({
  itemListElement: items.map((item, index) => ({
    '@type': 'ListItem',
    position: index + 1,
    name: item.name,
    item: `${ROOT_URL_HOST}${item.url}`,
  })),
});

export const buildFaqData = (questions: IFaqQuestion[]): FaqSchemaData => ({
  mainEntity: questions.map((question) => ({
    '@type': 'Question',
    name: question.title,
    acceptedAnswer: {
      '@type': 'Answer',
      text: question.text.replace(/<[^>]*>/g, ''),
    },
  })),
});
